export function $(selector,parent,avoidEscape){return(parent?parent:document).querySelector(avoidEscape?selector:selector.replace(/:/g,"\\:"))}export default $;